<p>
    <strong><i [class]="icon + ' text-muted text-color px-2'"></i>{{ label }} : </strong>
    <span [ngClass]="status === false ? 'text-danger' : 'text-success'">{{ value ?? '---'}}</span>
</p>